import { langPickerControll } from './lang-picker';

// ==================================================================================================
//
// Mobile Menu Functionality
//
// ==================================================================================================
const mobileMenuLogin = () => {
  let props = {
    isEnabled : false
  };

  let els = {};

  // Cache dom element selectors
  // ------------------------------------------------
  const createChildren = () => {
    els.$body          = $('body');
    els.$mobileMenuBtn = $('.js-mobile-menu-btn');
    els.$mobileMenu    = $('.js-mobile-menu');
    els.$mainMenu      = $('.js-main-menu');
    els.$jumpNav       = $('.js-jump-nav');
    els.$langPicker    = $('.lang_picker');
    return;
  }

  // Set up for responsive
  // ------------------------------------------------
  const setupResponsive = () => {
    return {
      'sm' : enable,
      'md' : enable,
      'lg' : disable,
      'xl' : disable
    }
  }

  // Add appropriate hover classes to control style
  // on non-hovered nav items
  // ------------------------------------------------
  const launchMobileMenu = (e) => {
    els.$body.toggleClass('modal-open');
    els.$mobileMenuBtn.children('.menu-hamburger').toggleClass('is-open');
    els.$mobileMenu.toggleClass('is-open');
    els.$mainMenu.toggleClass('is-mobile-open');
    els.$jumpNav.toggleClass('is-hidden');
    els.$langPicker.toggleClass('is-hidden');
    return;
  }
  

  // Enable
  // ------------------------------------------------
  const enable = () => {
    if (props.isEnabled) return;

    // Add your event handlers here
    els.$mobileMenuBtn.on('click', launchMobileMenu);

    props.isEnabled = true;

    return;
  }

  // Disable
  // ------------------------------------------------
  const disable = () => {
    if (!props.isEnabled) return;

    // Remove your event handlers here
    els.$mobileMenuBtn.off('click', launchMobileMenu);
    els.$body.removeClass('modal-open');
    els.$mobileMenuBtn.children('.menu-hamburger').removeClass('is-open');
    els.$mobileMenu.removeClass('is-open');
    els.$mainMenu.removeClass('is-mobile-open');
    els.$jumpNav.removeClass('is-hidden');

    props.isEnabled = false;

    return;
  }

  // Init
  // ------------------------------------------------
  const init = () => {
    createChildren();
    setupResponsive();
    langPickerControll('.lang_picker.mobile');
    return;
  }

  return {
    init,
    enable,
    disable,
    responsiveCallbacks: setupResponsive()
  };
}

export default mobileMenuLogin;
